import { DataSourceMode, DataSourceModeChangeEvent, Label, LookupModelSelectionEvent, TableRow, TableRowDisplayEvent, TableRowMode, Textbox } from "@mcleod/components";
import { LMECompanySettings } from "@mcleod/general";
import { AutogenLayoutProductBookTable } from "./autogen/AutogenLayoutProductBookTable";

export class ProductBookTable extends AutogenLayoutProductBookTable {

    override onLoad() {
        this.hideLtlColumns();
    }

    hideLtlColumns() {
        if (LMECompanySettings.getSingleton().isBrokerageLtl() == false) {
            this.tableProductBook.removeColumn("typeCode");
            this.tableProductBook.removeColumn("packaging");
            this.tableProductBook.removeColumn("weight");
            this.tableProductBook.removeColumn("nmfcClassCode");
            this.tableProductBook.removeColumn("spots");
            this.tableProductBook.removeColumn("handlingUnits");
            this.tableProductBook.removeColumn("cubicUnits");
            this.tableProductBook.removeColumn("productSKU");

            this.setColumnWidth("commodityCode", null);
            this.setColumnWidth("descr", null);
            this.setColumnWidth("isHazmat", null);
            this.setColumnWidth("hazmatNumber", null);
        }
    }

    sourceLocationCommodityAfterModeChange(event: DataSourceModeChangeEvent) {
        const isBrokerageLtl = LMECompanySettings.getSingleton().isBrokerageLtl();
        if (event.newMode === DataSourceMode.SEARCH) {
            this.tableProductBook.removeColumn("isHazmat");
            this.tableProductBook.removeColumn("hazmatNumber");
            if (isBrokerageLtl == true) {
                this.tableProductBook.removeColumn("typeCode");
                this.tableProductBook.removeColumn("packaging");
                this.tableProductBook.removeColumn("weight");
                this.tableProductBook.removeColumn("nmfcClassCode");
                this.tableProductBook.removeColumn("spots");
                this.tableProductBook.removeColumn("handlingUnits");
                this.tableProductBook.removeColumn("cubicUnits");
                this.tableProductBook.removeColumn("productSKU");
            }

            this.setColumnWidth("commodityCode", null);
            this.setColumnWidth("descr", null);
        }
        else if (isBrokerageLtl == false) {
            this.setColumnWidth("commodityCode", null);
            this.setColumnWidth("descr", null);
            this.setColumnWidth("isHazmat", null);
            this.setColumnWidth("hazmatNumber", null);
        }
        else {
            this.setColumnWidth("commodityCode", "15%");
            this.setColumnWidth("descr", "10%");
            this.setColumnWidth("typeCode", "5%");
            this.setColumnWidth("packaging", "5%");
            this.setColumnWidth("weight", "10%");
            this.setColumnWidth("nmfcClassCode", "5%");
            this.setColumnWidth("spots", "10%");
            this.setColumnWidth("handlingUnits", "10%");
            this.setColumnWidth("cubicUnits", "10%");
            this.setColumnWidth("isHazmat", "5%");
            this.setColumnWidth("hazmatNumber", "5%");
            this.setColumnWidth("productSKU", "10%");
        }
    }

    private setColumnWidth(columnId: String, width: string) {
        for (const column of this.tableProductBook.columns) {
            if (column?.cellDef?.def?.id === columnId) {
                this.tableProductBook.columns[column.index].headingCell.width = width;
                this.tableProductBook.columns[column.index].cellDef.def.width = width;
            }
        }
    }

    tableProductBookOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const data = event.getTableRow().data;
        const textboxCommodityId = tableRow.findComponentById("textboxCommodityId") as Textbox;
        const textboxDescr = tableRow.findComponentById("textboxDescr") as Textbox;
        const labelHazmat = tableRow.findComponentById("labelHazmat") as Label;
        const labelHazmatNumber = tableRow.findComponentById("labelHazmatNumber") as Label;
        const labelType = tableRow.findComponentById("labelType") as Label;
        const labelPackaging = tableRow.findComponentById("labelPackaging") as Label;
        const labelWeight = tableRow.findComponentById("labelWeight") as Label;
        const labelWeightIsPerPiece = tableRow.findComponentById("labelWeightIsPerPiece") as Label;
        const labelClass = tableRow.findComponentById("labelClass") as Label;
        const labelSpots = tableRow.findComponentById("labelSpots") as Label;
        const labelSpotsIsPerPiece = tableRow.findComponentById("labelSpotsIsPerPiece") as Label;
        const labelHandlingUnits = tableRow.findComponentById("labelHandlingUnits") as Label;
        const labelHandlingUnitsIsPerPiece = tableRow.findComponentById("labelHandlingUnitsIsPerPiece") as Label;
        const labelCubicUnits = tableRow.findComponentById("labelCubicUnits") as Label;
        const labelCubicUnitsIsPerPiece = tableRow.findComponentById("labelCubicUnitsIsPerPiece") as Label;
        const labelProductSKU = tableRow.findComponentById("labelProductSKU") as Label;

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            textboxDescr.printable = true;
        }

        const isBrokerageLtl = LMECompanySettings.getSingleton().isBrokerageLtl();
        if (tableRow.mode !== TableRowMode.SEARCH) {
            if (labelHazmat != null)
                labelHazmat.text = data.get("commodity.is_hazmat");
            if (labelHazmatNumber != null)
                labelHazmatNumber.text = data.get("commodity.hazmat_number");
            if (isBrokerageLtl == true) {
                if (labelType != null)
                    labelType.text = data.get("commodity.type_code");
                if (labelPackaging != null)
                    labelPackaging.text = data.get("commodity.packaging_type_code");
                if (labelWeight != null && data.get("commodity.weight") != null) {
                    const rawWeight = data.get("commodity.weight");
                    let numericWeight: Number;
                    if (typeof rawWeight === 'string') {
                        numericWeight = Number(rawWeight.replace(/,/g, ''));
                    } else {
                        numericWeight = Number(rawWeight);
                    }
                    labelWeight.text = numericWeight?.toFixed(2);
                }
                if (labelWeightIsPerPiece != null)
                    labelWeightIsPerPiece.text = (data.get("commodity.weight_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelClass != null)
                    labelClass.text = data.get("commodity.nmfc_class_code");
                if (labelSpots != null && data.get("commodity.req_spots") != null)
                    labelSpots.text = Number(data.get("commodity.req_spots"))?.toFixed(2);
                if (labelSpotsIsPerPiece != null)
                    labelSpotsIsPerPiece.text = (data.get("commodity.spots_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelHandlingUnits != null && data.get("commodity.handling_units") != null)
                    labelHandlingUnits.text = Number(data.get("commodity.handling_units"))?.toFixed();
                if (labelHandlingUnitsIsPerPiece != null)
                    labelHandlingUnitsIsPerPiece.text = (data.get("commodity.handling_units_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelCubicUnits != null && data.get("commodity.cubic_units") != null)
                    labelCubicUnits.text = Number(data.get("commodity.cubic_units"))?.toFixed(2);
                if (labelCubicUnitsIsPerPiece != null)
                    labelCubicUnitsIsPerPiece.text = (data.get("commodity.cubic_units_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelProductSKU != null) {
                    labelProductSKU.text = data.get("commodity.product_sku");
                    labelProductSKU.tooltip = labelProductSKU.text;
                }
            }
        }
        textboxCommodityId.addLookupModelSelectionListener(this.textboxCommodityIdOnLookupModelSelection);
    }

    private textboxCommodityIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() !== true)
            return;
        const tableRow = TableRow.getContainingTableRow(event.target);
        const data = tableRow.data;
        const textboxCommodityId = tableRow.findComponentById("textboxCommodityId") as Textbox;
        const textboxDescr = tableRow.findComponentById("textboxDescr") as Textbox;
        const labelHazmat = tableRow.findComponentById("labelHazmat") as Label;
        const labelHazmatNumber = tableRow.findComponentById("labelHazmatNumber") as Label;
        const labelType = tableRow.findComponentById("labelType") as Label;
        const labelPackaging = tableRow.findComponentById("labelPackaging") as Label;
        const labelWeight = tableRow.findComponentById("labelWeight") as Label;
        const labelWeightIsPerPiece = tableRow.findComponentById("labelWeightIsPerPiece") as Label;
        const labelClass = tableRow.findComponentById("labelClass") as Label;
        const labelSpots = tableRow.findComponentById("labelSpots") as Label;
        const labelSpotsIsPerPiece = tableRow.findComponentById("labelSpotsIsPerPiece") as Label;
        const labelHandlingUnits = tableRow.findComponentById("labelHandlingUnits") as Label;
        const labelHandlingUnitsIsPerPiece = tableRow.findComponentById("labelHandlingUnitsIsPerPiece") as Label;
        const labelCubicUnits = tableRow.findComponentById("labelCubicUnits") as Label;
        const labelCubicUnitsIsPerPiece = tableRow.findComponentById("labelCubicUnitsIsPerPiece") as Label;
        const labelProductSKU = tableRow.findComponentById("labelProductSKU") as Label;

        textboxDescr.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("descr");
        if (textboxDescr.text != "") textboxDescr.enabled = false;
        data.set("descr", textboxDescr.text);

        if (tableRow.mode !== TableRowMode.SEARCH) {
            labelHazmat.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("is_hazmat");
            data.set("commodity.is_hazmat", labelHazmat.text);

            labelHazmatNumber.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("hazmat_number");
            data.set("commodity.hazmat_number", labelHazmatNumber.text);

            const isBrokerageLtl = LMECompanySettings.getSingleton().isBrokerageLtl();
            if (isBrokerageLtl == true) {
                labelType.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("type_code");
                data.set("commodity.type_code", labelType.text);

                labelPackaging.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("packaging_type_code");
                data.set("commodity.packaging_type_code", labelPackaging.text);

                labelWeight.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("weight");
                data.set("commodity.weight", labelWeight.text);

                labelWeightIsPerPiece.text = (textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("weight_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelWeightIsPerPiece.text != null) data.set("commodity.weight_is_per_piece", "Y");

                labelClass.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("nmfc_class_code");
                data.set("commodity.nmfc_class_code", labelClass.text);

                labelSpots.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("req_spots");
                data.set("commodity.req_spots", labelSpots.text);

                labelSpotsIsPerPiece.text = (textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("spots_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelSpotsIsPerPiece.text != null) data.set("commodity.spots_is_per_piece", "Y");

                labelHandlingUnits.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("handling_units");
                data.set("commodity.handling_units", labelHandlingUnits.text);

                labelHandlingUnitsIsPerPiece.text = (textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("handling_units_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelHandlingUnitsIsPerPiece.text != null) data.set("commodity.handling_units_is_per_piece", "Y");

                labelCubicUnits.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("cubic_units");
                data.set("commodity.cubic_units", labelCubicUnits.text);

                labelCubicUnitsIsPerPiece.text = (textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("cubic_units_is_per_piece") == "Y") ? "/Piece" : null;
                if (labelCubicUnitsIsPerPiece.text != null) data.set("commodity.cubic_units_is_per_piece", "Y");

                labelProductSKU.text = textboxCommodityId.boundRow.getFirstLookupModelData("commodity_id")?.get("product_sku");
                labelProductSKU.tooltip = labelProductSKU.text;
                data.set("commodity.product_sku", labelProductSKU.text);
            }
        }
    }
}
